import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';
import { CheckboxGroup as CheckboxGroup$1 } from 'react-aria-components';

const checkboxGroupStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--zds-space-12, 8px);
  color: var(--zds-text-default, ${Colors.GrayWarm10});
`;
const optionsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--zds-space-12, 8px);

  & > label {
  }
`;
const CheckboxGroup = (_a) => {
  var { children, label, description, errorMessage, isRequired } = _a, props = __rest(_a, ["children", "label", "description", "errorMessage", "isRequired"]);
  return jsx(
    CheckboxGroup$1,
    Object.assign({ css: checkboxGroupStyles, "data-zds": true }, props),
    label && jsx(Label, { isRequired }, label),
    jsx("div", { css: optionsWrapperStyles }, children),
    description && jsx(Description, null, description),
    jsx(ErrorMessage, null, errorMessage)
  );
};

export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.es.js.map
